import { METRIC_DEFINITIONS } from '../../../shared/constants/metrics';
import useAnimatedCounter from '../hooks/useAnimatedCounter';

const DashboardHero = ({ teamsCount, averages, onRefresh, isRefreshing }) => {
  const animatedTeams = useAnimatedCounter(teamsCount, 900);
  const animatedOverall = useAnimatedCounter(averages.overall, 1400);

  return (
    <section className="dashboard-hero">
      <div className="dashboard-hero-content">        <div className="dashboard-hero-text">
          <span className="dashboard-hero-badge">Сводная аналитика</span>
          <h2 className="dashboard-hero-title">Дашборды команд</h2>
          <p className="dashboard-hero-subtitle">
            Сводная аналитика по всем направлениям — для презентаций и мониторинга прогресса
          </p>
        </div>

        <button
          type="button"
          className="dashboard-refresh-btn"
          onClick={onRefresh}
          disabled={isRefreshing}
          title="Обновить данные"
        >
          <span className={`dashboard-refresh-icon ${isRefreshing ? 'spinning' : ''}`}>↻</span>
          {isRefreshing ? 'Обновление…' : 'Обновить'}
        </button>
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi dashboard-kpi--primary" style={{ animationDelay: '0.05s' }}>
          <span className="dashboard-kpi-label">Команд</span>
          <span className="dashboard-kpi-value">{Math.round(animatedTeams)}</span>
        </div>

        <div className="dashboard-kpi dashboard-kpi--highlight" style={{ animationDelay: '0.12s' }}>
          <span className="dashboard-kpi-label">Средний балл</span>
          <span className="dashboard-kpi-value">{animatedOverall.toFixed(1)}%</span>
          <div className="dashboard-kpi-bar">
            <div
              className="dashboard-kpi-bar-fill"
              style={{ width: `${animatedOverall}%` }}
            />
          </div>
        </div>

        {METRIC_DEFINITIONS.map(({ key, title, detailColor }, index) => {
          const avg = averages[key] ?? 0;
          return (
            <div
              key={key}
              className="dashboard-kpi dashboard-kpi--metric"
              style={{ animationDelay: `${0.18 + index * 0.06}s` }}
            >
              <span className="dashboard-kpi-label" title={title}>
                {title}
              </span>
              <span
                className="dashboard-kpi-value dashboard-kpi-value--accent"
                style={{ color: detailColor }}
              >
                {avg.toFixed(1)}%
              </span>
              <div className="dashboard-kpi-bar">
                <div
                  className="dashboard-kpi-bar-fill"
                  style={{ width: `${avg}%`, background: detailColor }}
                />
              </div>
            </div>
          );
        })}      </div>
    </section>
  );
};

export default DashboardHero;
